import React from "react"
import "./Pdp.css"

const Radio = props => (
  <div className="PDP-Input">
    <div className="PDP-Radio">
      <input
        id={"radio-" + props.radionumber}
        class="radio-custom"
        name="radio-group"
        type="radio"
        checked
      />
      <label for={"radio-" + props.radionumber} class="radio-custom-label" />
    </div>
    <div className="PDP-Input-Details">
      <label className={props.labelclass}>{props.label}</label>
      <span className={props.descriptionclass}>{props.description}</span>
    </div>
  </div>
)

export default Radio
